import { render, staticRenderFns } from "./ObiPagination.vue?vue&type=template&id=60ec53a2&scoped=true&"
import script from "./ObiPagination.vue?vue&type=script&lang=js&"
export * from "./ObiPagination.vue?vue&type=script&lang=js&"
import style0 from "./ObiPagination.vue?vue&type=style&index=0&id=60ec53a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec53a2",
  null
  
)

export default component.exports